// Local-only persistence for the /content-admin maintenance panel.
// No backend, no database — everything lives in the browser (localStorage)
// until the operator manually applies changes to the source files and
// redeploys. See ContentAdmin.tsx for the full disclaimer shown to users.

const STORAGE_KEY = "motorpro_content_admin_v1";
const UPDATE_EVENT = "motorpro-content-updated";

export interface AdminVehicleOverride {
  id: number;
  title: string;
  price: string;
  location: string;
  mileage: string;
  badge: string;
  url: string;
  image: string;
  imagePath: string;
}

export interface AdminOverridesShape {
  fields: Record<string, string>;
  vehicles: AdminVehicleOverride[] | null;
}

const EMPTY: AdminOverridesShape = { fields: {}, vehicles: null };

export function loadOverrides(): AdminOverridesShape {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...EMPTY };
    const parsed = JSON.parse(raw);
    return { fields: parsed.fields || {}, vehicles: parsed.vehicles || null };
  } catch {
    return { ...EMPTY };
  }
}

export function saveOverrides(data: AdminOverridesShape) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    window.dispatchEvent(new Event(UPDATE_EVENT));
  } catch {
    // Storage full or unavailable — edits still work for the current session.
  }
}

export function clearOverrides() {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event(UPDATE_EVENT));
}
